import React from 'react';

const NotFound = () => {
    return (
        <div className="not_found_container">
            <div>
                <div>Sorry <span role="img" aria-label="emoji">😞</span></div>
                <div>Page Not Found</div>                
            </div>
        </div>
    );
};

export default NotFound;